import {
    Box,
    Button,
    CircularProgress,
    Grid,
    TextField,
    useTheme,
} from "@mui/material";
import { ChangeEvent, FormEvent, useContext, useEffect, useState } from "react";
import { Global_CTX } from "../../contexts/global-ctx";
import { Add } from "@mui/icons-material";
import {
    Device_Service,
    Device_Status,
    INew_Device,
} from "../../services/device/device-service";
import { Autocomplete } from "../Autocomplete/Autocomplete";
import UserContext, { User_Type } from "../UserContext";

const initial_device: INew_Device = {
    serial: "",
    // status: Device_Status["In-Active"],
    branch: "",
    name: "",
    firmwareVersion: "",
    faceVersion: "",
    fpVersion: "",
    platform: "",
    organization: "",
};

export default function Create_Device_Form() {
    const [device, set_device] = useState(initial_device);
    const { feedback, set_feedback, set_refetch_counter } =
        useContext(Global_CTX);
    const { user } = useContext(UserContext);
    const theme = useTheme();

    const handle_change = (ev: ChangeEvent<HTMLInputElement>) => {
        const value = ev.target.value;
        set_device({
            ...device,
            [ev.target.name]: value,
        });
    };

    const handle_submit = async (ev: FormEvent) => {
        ev.preventDefault();

        set_feedback({ ...feedback, loading: true });

        const [data, error] = await Device_Service.create_device(
            device
            // org_api_key_map[device.organization] || ""
        );

        if (error) {
            console.log(error);

            set_feedback({
                loading: false,
                message: { title: error?.message ?? "" },
                severity: "error",
                show: true,
            });
            return;
        }

        set_refetch_counter((n) => n + 1);

        set_feedback({
            loading: false,
            message: { title: data?.message ?? "" },
            severity: "success",
            show: true,
        });
    };

    useEffect(() => {
        if (user?.user_type === User_Type.Admin) {
            set_device((d) => ({ ...d, organization: user.organization.code }));
        }
    }, [user?.user_type]);

    return (
        <form onSubmit={handle_submit}>
            <Grid container spacing={1}>
                <Grid item md={4} xl={3}>
                    <TextField
                        label="Serial"
                        fullWidth
                        value={device.serial}
                        name="serial"
                        onChange={handle_change}
                        required
                    />
                </Grid>

                <Grid item md={4} xl={3}>
                    <TextField
                        label="Name"
                        fullWidth
                        value={device.name}
                        name="name"
                        onChange={handle_change}
                        required
                    />
                </Grid>

                {/* <Grid item md={4} xl={3}>
                    <Autocomplete
                        label="Status"
                        labelKey="label"
                        setOutput={(
                            status: { label: keyof typeof Device_Status } | ""
                        ) =>
                            set_device((curr) => ({
                                ...curr,
                                status: status
                                    ? Device_Status[status.label]
                                    : ("" as any),
                            }))
                        }
                        defaultOptions={Object.keys(Device_Status).map(
                            (label, id) => ({
                                label,
                                id,
                            })
                        )}
                    />
                </Grid> */}

                {user?.user_type === User_Type.Superadmin && (
                    <Grid item md={4} xl={3}>
                        <Autocomplete
                            key={`org-input`}
                            api="/organization"
                            label="Organization"
                            labelKey="name"
                            setOutput={(org) =>
                                set_device((curr) => ({
                                    ...curr,
                                    organization: org ? org.code : "",
                                }))
                            }
                        />
                    </Grid>
                )}

                <Grid item md={4} xl={3}>
                    <Autocomplete
                        key={`branch-input`}
                        label="Branch"
                        labelKey="name"
                        setOutput={(branch) =>
                            set_device((curr) => ({
                                ...curr,
                                branch: branch?.id ?? "",
                            }))
                        }
                        api={
                            user?.user_type === User_Type.Admin
                                ? "/organization/branch"
                                : "/organization/branch/superadmin"
                        }
                        apiParams={{
                            organization: device.organization,
                        }}
                        request_headers={{
                            "x-org": device.organization,
                        }}
                    />
                </Grid>

                <Grid item md={4} xl={3}>
                    <TextField
                        label="Face Version"
                        fullWidth
                        value={device.faceVersion}
                        name="faceVersion"
                        onChange={handle_change}
                        required
                    />
                </Grid>

                <Grid item md={4} xl={3}>
                    <TextField
                        label="Firm Version"
                        fullWidth
                        value={device.firmwareVersion}
                        name="firmwareVersion"
                        onChange={handle_change}
                        required
                    />
                </Grid>

                <Grid item md={4} xl={3}>
                    <TextField
                        label="Platform"
                        fullWidth
                        value={device.platform}
                        name="platform"
                        onChange={handle_change}
                        required
                    />
                </Grid>

                <Grid item md={4} xl={3}>
                    <TextField
                        label="FP Version"
                        fullWidth
                        value={device.fpVersion}
                        name="fpVersion"
                        onChange={handle_change}
                        required
                    />
                </Grid>

                <Grid item md={4} xl={3}>
                    <Button
                        sx={{ height: "100%" }}
                        type="submit"
                        variant="contained"
                        disabled={feedback.loading}
                        startIcon={
                            feedback.loading ? (
                                <CircularProgress size="1em" />
                            ) : (
                                <Add />
                            )
                        }
                    >
                        {feedback.loading
                            ? "Creating Device..."
                            : "Create Device"}

                        {/* {!updateMode
              ? feedback.loading
                ? "Adding session..."
                : "Add session"
              : feedback.loading
                ? "updating session..."
                : "update session"} */}
                    </Button>
                </Grid>
            </Grid>

            {/* <TextField
        label="Address"
        // multiline
        // minRows={3}
        fullWidth
        value={device.address}
        name="address"
        onChange={handle_change}
        sx={{ flex: 1 }}
        required
      /> */}

            {/* <Feedback /> */}
        </form>
    );
}
